import EmbedCCSP from "@/components/EmbedCCSP";

const CCSPEmbed = () => {
  // Get URL parameters for customization
  const urlParams = new URLSearchParams(window.location.search);
  const compact = urlParams.get('compact') === 'true';
  const showHero = urlParams.get('hero') !== 'false';
  const showQuickFacts = urlParams.get('facts') !== 'false';
  const showLearningAreas = urlParams.get('learning') !== 'false';
  const showEligibility = urlParams.get('eligibility') !== 'false';
  const showFramework = urlParams.get('framework') !== 'false';
  const showApplication = urlParams.get('application') !== 'false';
  const showIdealFor = urlParams.get('ideal') !== 'false';
  const showNextSteps = urlParams.get('steps') !== 'false';
  const maxWidth = urlParams.get('width') || '6xl';

  return (
    <EmbedCCSP 
      compact={compact}
      showHero={showHero}
      showQuickFacts={showQuickFacts}
      showLearningAreas={showLearningAreas}
      showEligibility={showEligibility}
      showFramework={showFramework}
      showApplication={showApplication}
      showIdealFor={showIdealFor}
      showNextSteps={showNextSteps}
      maxWidth={maxWidth}
    />
  );
};

export default CCSPEmbed;